import { Component } from "react"
import PropTypes from "prop-types"

import { partialStoryShape } from "app/lib/shared_prop_types"
import loadHeroImage from "shared/lib/load_hero_image"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import truncate from "lodash/truncate"

import "./story_card.scss"

class StoryCard extends Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "discover",
      object_id: this.props.story.id,
      object_type: "story",
      position: this.props.position,
      slug: this.props.story.slug,
    })
  }

  render() {
    return (
      <a
        href={`/${this.props.singleStoryBasePath}/${this.props.story.slug}`}
        rel="noreferrer"
        styleName="story-card"
      >
        <div
          styleName="hero"
          title={this.props.story.title}
          aria-label={this.props.story.title}
          style={{
            backgroundColor: `${this.props.story.hero_image["background_color"]}`,
          }}
          onClick={this.handleOnClick}
        >
          <img
            src={loadHeroImage(this.props.story.hero_image)}
            title={this.props.story.title}
            alt={this.props.story.title}
            loading="lazy"
            width="336"
            height="200"
          />
        </div>
        <div styleName="title">
          <h2>{this.props.story.title}</h2>
        </div>

        <p styleName="description">
          {truncate(this.props.story.description, {
            length: 240,
            separator: /[ ,]/,
          })}
        </p>
      </a>
    )
  }
}

StoryCard.propTypes = {
  story: partialStoryShape.isRequired,
  position: PropTypes.number.isRequired,
  singleStoryBasePath: PropTypes.string.isRequired,
}

export default StoryCard
